import React, { useState } from 'react';
import { GoogleMap, LoadScript, Marker, Polygon, Polyline, InfoWindow } from '@react-google-maps/api';
import { googleMapsApiKey } from '../../Urls/Services/Api_urls';
import jsonpol from '../../assets/servicio_fibra/json/cobertura.json';
import jsonpoline from '../../assets/servicio_fibra/json/pl_v2.json';
import jsonode from '../../assets/servicio_fibra/json/nodos_v2.json';
import Navbar from '../Navbar/Navbar';
import { IconoirContext } from 'iconoir-react';

export const MapaCobertura = () => {
  // Estilos y centro del mapa
  const containerStyle = {
    width: '100%',
    height: '100vh'
  };
  const center = {
    lat: 3.6850139010000453,
    lng: -76.564036637999948,
  };

  // Estados para gestionar los elementos seleccionados
  const [selectedPolyline, setSelectedPolyline] = useState(null);
  const [selectedNode, setSelectedNode] = useState(null);

  // Manejadores de eventos de clic en los elementos
  const handleNodeClick = (index) => {
    setSelectedNode(index);
  };

  const handleCloseInfoWindowNode = () => {
    setSelectedNode(null);
  };

  const handlePolylineClick = (index) => {
    setSelectedPolyline(index);
  };

  const handleCloseInfoWindow = () => {
    setSelectedPolyline(null);
  };

  const convertToLatLng = (array) => {
    let path = [];
    array.forEach((point) => {
      path.push({ lat: point[1], lng: point[0] });
    });
    return path;
  }


  // Conversión de datos del JSON en coordenadas para los polígonos y polilíneas
  const paths = jsonpol.features.map(feature => feature.geometry.rings[0].map(coord => ({ lat: coord[1], lng: coord[0] })));
  const poly = [];
  const polyFeatureMap = []; // Mapeo de índices

  jsonpoline.features.forEach((line, featureIndex) => {
    line.geometry.paths.forEach((path) => {
      if (Array.isArray(path[0][0])) {
        // Caso con múltiples arrays internos
        path.forEach((subPath) => {
          poly.push(convertToLatLng(subPath));
          polyFeatureMap.push(featureIndex); // Mapea el índice del feature
        });
      } else {
        // Caso con un solo array
        poly.push(convertToLatLng(path));
        polyFeatureMap.push(featureIndex); // Mapea el índice del feature
      }
    });
  });

  return (
    <>
      <Navbar />
      <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
        <div style={{ width: "100%" }}>
          <LoadScript
            googleMapsApiKey={googleMapsApiKey}
            libraries={['places']}
          >
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={10}
            >
              {/* Renderizado de polígonos */}
              {paths.map((path, index) => (
                <React.Fragment key={index}>
                  <Polygon
                    paths={path}
                    options={{
                      strokeColor: '#000',
                      strokeOpacity: 0.3,
                      strokeWeight: 2,
                      fillColor: '#F19101',
                      fillOpacity: 0.5
                    }}
                  
                  />
             
                </React.Fragment>
              ))}

              {/* Renderizado de polilíneas */}
              {poly.map((path, index) => (
                <React.Fragment key={index}>
                  <Polyline
                    path={path}
                    options={{
                      strokeColor: '#FF0000',
                      strokeOpacity: 1,
                      strokeWeight: 4
                    }}
                    onClick={() => handlePolylineClick(index)}
                  />
                  {/* InfoWindow asociado a la polilínea seleccionada */}
                  {selectedPolyline === index && (
                    <InfoWindow
                      position={path[0]}
                      onCloseClick={handleCloseInfoWindow}
                      options={{ disableAutoPan: true }} 
                    >
                      <div>
            
                      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                          <tbody>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>NIT</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.nit}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>ID_ENLACE(Código único deL Tramo o Enlace)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.Name}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                                <b>TOPOLOGIA(Tipo de topología)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.TOPOLOGIA}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                                <b>ID_RED_TOP(Identificador de red según la topología)</b></td>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.ID_RED_TOP}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>
                                <b>TITULAR(Titularidad al derecho de uso)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.TITULAR}</td>
                            </tr>
                            {/* <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_INS_MB(Capacidad instalada en[Mbps])</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.CAP_INS_MB}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_UT_MB(Capacidad utilizada en[Mbps])</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.CAP_UT_MB}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_INS_HI(Capacidad instalada en cantidad de hilos)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.CAP_INS_HI}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_U_P_HI(Capacidad utilizada por el mismo PRST en cantidad de hilos)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.CAP_U_P_HI}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_ARR_HI(Capacidad arrendada a terceros en cantidad de hilos)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.CAP_ARR_HI}</td>
                            </tr>
                            <tr>
                              <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>HILOS_OFF(Capacidad de hilos no iluminados)</b></td>
                              <td style={{ border: '1px solid #ddd', padding: '8px' }}>{jsonpoline.features[polyFeatureMap[index]].attributes.HILOS_OFF}</td>
                            </tr> */}
                          </tbody>
                        </table>
                        {/* Agregar más información según sea necesario */}
                      </div>
                    </InfoWindow>
                  )}
                </React.Fragment>
              ))}

              {/* Renderizado de marcadores */}
              {jsonode.features.map((feature, index) => (
                <React.Fragment key={index}>
                  <Marker
                    position={{ lat: feature.geometry.y, lng: feature.geometry.x }}
                    title={feature.attributes.Name}
                    icon={{
                      url: require('../../assets/servicio_fibra/markers/node.png'),
                    }}
                    onClick={() => handleNodeClick(index)}
                  />
                  {/* InfoWindow asociado al marcador seleccionado */}
                  {selectedNode === index && (
                    <InfoWindow
                      position={{ lat: feature.geometry.y, lng: feature.geometry.x }}
                      onCloseClick={handleCloseInfoWindowNode}
                      options={{ disableAutoPan: true }} 
                    >
                      <div>
                      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <tbody>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>NIT</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.nit}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>ID_NODO (Código único del Nodo)</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.id_nodo}</td>
                          </tr>
                          {/* <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_INS_MB (Capacidad instalada en [Mbps])</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.CAP_INS_MB}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_INS_IX (Capacidad instalada interconectable en [Mbps])</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.CAP_INS_IX}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>CAP_INS_HI (Capacidad instalada en cantidad de hilos)</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.CAP_INS_HI}</td>
                          </tr> */}
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>Nombre municipio</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.nombre_municipio}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>OID</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.OID}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>Código municipio</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.codigo_municipio}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>Nombre departamento</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.nombre_departamento}</td>
                          </tr>
                          <tr>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}><b>Tecnología</b></td>
                            <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>{feature.attributes.tecnologia}</td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                    </InfoWindow>
                  )}
                </React.Fragment>
              ))}

              {/* Renderizado de marcadores polilínea */}
              
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    </>
  );
};